import axios, { AxiosRequestConfig } from 'axios';

import applyCaseMiddleware from 'axios-case-converter';

const preservedKeys = ['_id'];

export function createRequest(config?: AxiosRequestConfig) {
    return applyCaseMiddleware(axios.create(config), {
        preservedKeys,
    });
}
